import { AADetectionResults, AdBlockerType, PageViewEventType } from "../types";
import { sendEvent } from "../utils";
import { log } from "../utils/logs";

export const onPageView = (
  aaDetectionResults: AADetectionResults,
  detectedExtension: AdBlockerType,
  consentMessageShown: boolean,
) => {
  if (!window.__bt_intrnl.rlPVSent) {
    window.__bt_intrnl.rlPVSent = true;
    let event: PageViewEventType = "non_ab_pageview";
    if (aaDetectionResults.ab) {
      event = aaDetectionResults.acceptable ? "aa_pageview" : "ab_pageview";
    }

    sendEvent({
      event,
      detectedExtension,
      consentMessageShown,
    }).catch((error) => {
      log(
        "rlink.onPageViewError",
        {
          version: __SCRIPT_VERSION__,
          aaResults: window.__bt_intrnl.aaDetectionResults,
          error: error instanceof Error ? error.message : error,
        },
        { severity: 4 },
      );
    });
  }
};
